export enum AllianzJobStatus {
    Pending = 'PENDING',
    Processed = 'PROCESSED',
    TechnicalError = 'TECHNICAL_ERROR',
    FunctionalError = 'FUNCTIONAL_ERROR',
}
